<template>
  <div id="event-menu">
    <div class="sidebar sidebar-light sidebar-main sidebar-expand-md align-self-start">
      <div class="sidebar-content">
        <div class="menu-search-wrapper">
          <input v-model="searchTerm" type="text" class="form-control" :placeholder="$t('event.textbox.search_')" />
          <i class="fas fa-search"></i>
        </div>

        <div class="card-sidebar-mobile">
          <div class="card-body p-0">
            <ul class="nav nav-sidebar" data-nav-type="accordion">
              <template v-for="item in getMenuItems">
                <li class="nav-item-header mt-0" v-if="item.seperator" :key="item.slug">
                  <div class="menu-title-custom">
                    {{ item.title }}
                  </div>
                  <i class="icon-menu" title="Main"></i>
                </li>

                <li v-if="item.seperator == false" class="nav-item" :style="searchTerm != null && searchTerm != '' ? 'nav-item-open' : ''" :key="item.slug" :class="item.children.length != 0 ? 'nav-item-submenu' : ''">
                  <router-link class="nav-link" :to="{ name: item.slug }" v-if="item.children.length == 0" exact>
                    <!-- <i class="menuicon-svg" :style="'background-image: url(/static/images/menuicons/' + item.icon + '.svg)'"></i> -->
                    <i :class="item.icon"></i>

                    <span>{{ item.title }}</span>
                    <div v-if="statistics.some(x => x.key == item.key && x.value != null)" class="menu-custom-badge">{{ statistics.find(x => x.key == item.key).value }}</div>
                  </router-link>

                  <span class="nav-link" :key="item.slug" v-if="item.children.length != 0" style="cursor: pointer">
                    <!-- <i class="menuicon-svg" :style="'background-image: url(/static/images/menuicons/' + item.icon + '.svg)'"></i> -->
                    <i :class="item.icon"></i>
                    <span>{{ item.title }}</span>
                    <div v-if="statistics.some(x => x.group == item.group && x.value != null)" class="menu-custom-circle"><div class="pulse"></div></div>
                  </span>

                  <ul v-if="item.children.length != 0" class="nav nav-group-sub" :style="searchTerm != null && searchTerm != '' ? 'display: block' : ''" :data-submenu-title="item.title">
                    <li class="nav-item" v-for="child in getSubMenuItems(item.slug)" :key="child.slug">
                      <router-link class="nav-link" :to="{ name: child.slug }">
                        <span>{{ child.title }}</span>
                        <div v-if="statistics.some(x => x.key == child.key && x.value != null)" class="menu-custom-badge">{{ statistics.find(x => x.key == child.key).value }}</div>
                      </router-link>
                    </li>
                  </ul>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import slugify from "slugify";
import $ from "jquery";
import axios from "axios";

export default {
  name: "EventMenu",
  data() {
    return {
      menuKey: +new Date(),
      axios,
      statistics: [],
      menus: [
        {
          title: this.$t("event.menu.eventstart.title"),
          seperator: true,
          children: [],
          tags: [],
          role: [1, 2, 3, 4, 5, 6, 7, 8]
        },
        {
          title: this.$t("event.menu.eventhome.title"),
          icon: "fas fa-map-marker",
          tags: this.$t("event.menu.eventhome.searchterms"),
          seperator: false,
          slug: "event",
          children: [],
          group: "Event",
          role: [1, 2, 3, 4, 5, 6, 7, 8]
        },

        {
          title: this.$t("event.menu.reports.title"),
          icon: "fas fa-chart-pie",
          tags: this.$t("event.menu.reports.searchterms"),
          seperator: false,
          slug: "dashboard",
          children: [],
          group: "Reports",
          role: [1, 2, 3, 4, 5, 6]
        },

        {
          title: this.$t("event.menu.salesregistrations.title"),
          seperator: true,
          children: [],
          tags: [],
          role: [1, 2, 3, 5, 6, 8]
        },
        {
          title: this.$t("event.participantManagament.title"),
          icon: "fas fa-id-badge",
          tags: this.$t("event.menu.registrationmanagement.searchterms"),
          seperator: false,
          slug: "katilimci-yonetimi",
          group: "ParticipantManagement",
          role: [1, 2, 3, 5, 6, 8],
          children: [
            {
              title: this.$t("event.menu.registrationsearch.title"),
              icon: "search",
              tags: this.$t("event.menu.registrationsearch.searchterms"),
              seperator: false,
              slug: "search",
              children: [],
              role: [1, 2, 3, 5, 6, 8]
            },
            {
              title: this.$t("event.menu.participants.title"),
              icon: "list",
              tags: this.$t("event.menu.participants.searchterms"),
              seperator: false,
              badge: "0",
              slug: "participants",
              children: [],
              key: "Participant",
              role: [1, 2, 3, 5, 6, 8]
            },
            {
              title: this.$t("event.menu.registrationtags.title"),
              icon: "",
              tags: this.$t("event.menu.registrationtags.searchterms"),
              badge: "0",
              slug: "tags",
              key: "Segmentation",
              role: [1, 2, 3, 5]
            }
          ]
        },

        {
          title: this.$t("event.menu.registrationmanagement.title"),
          icon: "fas fa-pen-alt",
          group: "Registration",
          tags: this.$t("event.menu.registrationmanagement.searchterms"),
          seperator: false,
          slug: "sub-event-registrations",
          role: [1, 2, 3, 5],

          children: [
            {
              title: this.$t("event.menu.salesconfirmations.title"),
              icon: "",
              tags: this.$t("event.menu.salesconfirmations.searchterms"),
              badge: "0",
              slug: "payments",
              key: "Payment",
              role: [1, 2, 3, 5]
            },
            {
              title: this.$t("event.menu.registrationforms.title"),
              icon: "",
              tags: this.$t("event.menu.registrationforms.searchterms"),
              slug: "new-registration-form",
              role: [1, 2, 3, 5]
            }

            // {
            //   title: this.$t("event.menu.subeventregistrations.title"),
            //   icon: "",
            //   tags: this.$t("event.menu.subeventregistrations.searchterms"),
            //   slug: "sub-events",
            //   key: "SubEvent",
            //   role: [1, 2, 3, 5]
            // },
            // {
            //   title: this.$t("event.menu.additionalProduct.title"),
            //   icon: "",
            //   tags: this.$t("event.menu.additionalProduct.searchterms"),
            //   slug: "additional-products",
            //   key:'AdditionalProducts',
            //   role: [1, 2, 3, 5]
            // }
          ]
        },

        // {
        //   title: 'Abstract Yönetimi',
        //   icon: 'fas fa-pen-fancy',
        //   tags: this.$t('event.menu.reports.searchterms'),
        //   seperator: false,
        //   slug: 'abstract-management',
        //   children: [],
        //   key:"Abstract"
        // },
        {
          title: this.$t("event.menu.contentsmoderation.title"),
          seperator: true,
          children: [],
          tags: [],
          role: [1, 2, 3, 4]
        },

        {
          title: this.$t("event.menu.cms.title"),
          icon: "fas fa-box-open",
          tags: this.$t("event.menu.cms.searchterms"),
          seperator: false,
          slug: "content-management",
          group: "ContentManagement",
          role: [1, 2, 3, 4],

          children: [
            {
              title: this.$t("event.menu.speakers.title"),
              icon: "",
              tags: this.$t("event.menu.speakers.searchterms"),
              badge: "0",
              slug: "speakers",
              key: "Speaker",
              role: [1, 2, 3, 4]
            },

            {
              title: this.$t("event.menu.program.title"),
              icon: "",
              tags: this.$t("event.menu.program.searchterms"),
              badge: "0",
              slug: "program",
              key: "Program",
              role: [1, 2, 3, 4]
            },

            {
              title: this.$t("event.menu.sponsors.title"),
              icon: "",
              tags: this.$t("event.menu.sponsors.searchterms"),
              badge: "0",
              slug: "sponsors",
              key: "Sponsor",
              role: [1, 2, 3, 4]
            },

            {
              title: this.$t("event.menu.exhibitors.title"),
              icon: "",
              tags: this.$t("event.menu.exhibitors.searchterms"),
              badge: "0",
              slug: "stands",
              key: "Stand",
              role: [1, 2, 3, 4]
            },
            {
              title: this.$t("event.menu.networkingrooms.title"),
              icon: "",
              tags: this.$t("event.menu.networkingrooms.searchterms"),
              badge: "0",
              slug: "networking",
              key: "Networking",
              role: [1, 2, 3, 4]
            },
            {
              title: this.$t("event.menu.album.title"),
              icon: "",
              tags: this.$t("event.menu.documents.searchterms"),
              badge: "0",
              slug: "event-album",
              key: "Album",
              role: [1, 2, 3, 4]
            },
            {
              title: this.$t("event.menu.documents.title"),
              icon: "",
              tags: this.$t("event.menu.documents.searchterms"),
              badge: "0",
              slug: "files",
              key: "Document",
              role: [1, 2, 3, 4]
            },

            {
              title: this.$t("event.menu.faq.title"),
              icon: "",
              tags: this.$t("event.menu.faq.searchterms"),
              badge: "0",
              slug: "questionlibrary",
              key: "QuestionLibrary",
              role: [1, 2, 3, 4]
            },
            {
              title: this.$t("event.menu.areamap.title"),
              icon: "",
              tags: this.$t("event.menu.areamap.searchterms"),
              badge: "0",
              slug: "area-maps",
              key: "AreaMap",
              role: [1, 2, 3, 4]
            }
          ]
        },

        {
          title: this.$t("event.menu.livesessions.title"),
          icon: "fas fa-video",
          tags: this.$t("event.menu.livesessions.searchterms"),
          seperator: false,
          badge: "0",
          slug: "live-sessions",
          children: [],
          key: "Session",
          role: [1, 2, 3]
        },

        {
          title: this.$t("event.helpful.title"),
          seperator: true,
          children: [],
          tags: [],
          role: [1, 2, 3]
        },
        {
          title: this.$t("event.menu.messages.title"),
          icon: "fas fa-mail-bulk",
          tags: this.$t("event.menu.messages.searchterms"),
          seperator: false,
          badge: "0",
          slug: "automated-messages",
          children: [],
          role: [1, 2, 3]
        },
        {
          title: this.$t("event.menu.onsiteutilities.title"),
          icon: "fas fa-swatchbook",
          tags: this.$t("event.menu.onsiteutilities.searchterms"),
          seperator: false,
          slug: "modules",
          role: [1, 2, 3],

          children: [
            {
              title: this.$t("event.menu.certificastes.title"),
              icon: "",
              tags: this.$t("event.menu.certificastes.searchterms"),
              badge: "0",
              slug: "certificates",
              role: [1, 2, 3]
            },
            {
              title: this.$t("event.menu.badgedesigner.title"),
              icon: "",
              tags: this.$t("event.menu.badgedesigner.searchterms"),
              badge: "0",
              slug: "print-scheme",
              role: [1, 2, 3]
            },

            {
              title: this.$t("event.menu.controlpoints.title"),
              icon: "",
              tags: this.$t("event.menu.controlpoints.searchterms"),
              badge: "0",
              slug: "venues",
              role: [1, 2, 3]
            },

            {
              title: this.$t("event.menu.promotions.title"),
              icon: "",
              tags: this.$t("event.menu.promotions.searchterms"),
              badge: "0",
              slug: "promotions",
              role: [1, 2, 3]
            }
          ]
        }
      ],

      // menus: [

      //   {
      //     title: this.$t("event.menu.registrationsearch.title"),
      //     icon: "search",
      //     tags: this.$t("event.menu.registrationsearch.searchterms"),
      //     seperator: false,
      //     slug: "search",
      //     children: [],
      //   },

      //   {
      //     title: this.$t("event.menu.participants.title"),
      //     icon: "list",
      //     tags: this.$t("event.menu.participants.searchterms"),
      //     seperator: false,
      //     badge: "0",
      //     slug: "participants",
      //     children: [],
      //   },

      //   {
      //     title: this.$t("event.menu.registrationmanagement.title"),
      //     icon: "registration",
      //     tags: this.$t("event.menu.registrationmanagement.searchterms"),
      //     seperator: false,
      //     slug: "sub-event-registrations",
      //     children: [
      //         {
      //           title: this.$t("event.menu.registrationforms.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.registrationforms.searchterms"),
      //           slug: "registration-form",
      //         },

      //         {
      //           title: this.$t("event.menu.registrationgroups.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.registrationgroups.searchterms"),
      //           badge: "0",
      //           slug: "groups",
      //         },

      //         {
      //           title: this.$t("event.menu.registrationtags.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.registrationtags.searchterms"),
      //           badge: "0",
      //           slug: "tags",
      //         },

      //         {
      //           title: this.$t("event.menu.registrationpackages.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.registrationpackages.searchterms"),
      //           badge: "0",
      //           slug: "packets",
      //         },

      //         {
      //           title: this.$t("event.menu.couponcodes.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.couponcodes.searchterms"),
      //           badge: "0",
      //           slug: "coupons",
      //         },

      //         {
      //           title: this.$t("event.menu.salesconfirmations.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.salesconfirmations.searchterms"),
      //           badge: "0",
      //           slug: "payments",
      //         },

      //         {
      //           title: this.$t("event.menu.subeventregistrations.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.subeventregistrations.searchterms"),
      //           slug: "sub-event-registration",
      //         },

      //     ],
      //   },

      //   {
      //     title: this.$t("event.menu.eventstore.title"),
      //     icon: "store",
      //     tags: this.$t("event.menu.eventstore.searchterms"),
      //     seperator: false,
      //     badge: "0",
      //     slug: "sub-activities",
      //     children: [],
      //   },

      //   {
      //     title: this.$t("event.menu.accomodation.title"),
      //     icon: "hotel",
      //     tags: this.$t("event.menu.accomodation.searchterms"),
      //     seperator: false,
      //     badge: "0",
      //     slug: "accomodation-transfer",
      //     children: [],
      //   },

      //   {
      //     title: this.$t("event.menu.abstract.title"),
      //     icon: "abstract",
      //     tags: this.$t("event.menu.abstract.searchterms"),
      //     seperator: false,
      //     badge: "0",
      //     slug: "abstract-management",
      //     children: [],
      //   },

      //   {
      //     title: this.$t("event.menu.contentsmoderation.title"),
      //     seperator: true,
      //     children: [],
      //     tags: [],
      //   },

      //   {
      //     title: this.$t("event.menu.cms.title"),
      //     icon: "cms",
      //     tags: this.$t("event.menu.cms.searchterms"),
      //     seperator: false,
      //     slug: "content-management",
      //     children: [
      //         {
      //           title: this.$t("event.menu.speakers.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.speakers.searchterms"),
      //           badge: "0",
      //           slug: "speakers",
      //         },

      //         {
      //           title: this.$t("event.menu.program.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.program.searchterms"),
      //           badge: "0",
      //           slug: "program",
      //         },

      //         {
      //           title: this.$t("event.menu.sponsors.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.sponsors.searchterms"),
      //           badge: "0",
      //           slug: "sponsors",
      //         },

      //         {
      //           title: this.$t("event.menu.areamap.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.areamap.searchterms"),
      //           badge: "0",
      //           slug: "area-maps",
      //         },

      //         {
      //           title: this.$t("event.menu.exhibitors.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.exhibitors.searchterms"),
      //           badge: "0",
      //           slug: "stands",
      //         },

      //         {
      //           title: this.$t("event.menu.documents.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.documents.searchterms"),
      //           badge: "0",
      //           slug: "files",
      //         },

      //         {
      //           title: this.$t("event.menu.faq.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.faq.searchterms"),
      //           badge: "0",
      //           slug: "questionlibrary",
      //         },

      //     ],
      //   },

      //   {
      //     title: this.$t("event.menu.moderation.title"),
      //     icon: "moderation",
      //     tags: this.$t("event.menu.moderation.searchterms"),
      //     seperator: false,
      //     slug: "moderation",
      //     children: [
      //         {
      //           title: this.$t("event.menu.reviews.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.reviews.searchterms"),
      //           badge: "0",
      //           slug: "programrate",
      //         },

      //         {
      //           title: this.$t("event.menu.socialhub.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.socialhub.searchterms"),
      //           badge: "0",
      //           slug: "social",
      //         },

      //         {
      //           title: this.$t("event.menu.surveys.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.surveys.searchterms"),
      //           badge: "0",
      //           slug: "surveys",
      //         },

      //         {
      //           title: this.$t("event.menu.polls.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.polls.searchterms"),
      //           badge: "0",
      //           slug: "polls",
      //         },

      //         {
      //           title: this.$t("event.menu.questions.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.questions.searchterms"),
      //           badge: "0",
      //           slug: "walls",
      //         },

      //         {
      //           title: this.$t("event.menu.networkingrooms.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.networkingrooms.searchterms"),
      //           badge: "0",
      //           slug: "networking",
      //         },

      //     ],
      //   },

      //   {
      //     title: this.$t("event.menu.livesessions.title"),
      //     icon: "live",
      //     tags: this.$t("event.menu.livesessions.searchterms"),
      //     seperator: false,
      //     badge: "0",
      //     slug: "live-sessions",
      //     children: [],
      //   },

      //   {
      //     title: this.$t("event.menu.modules.title"),
      //     seperator: true,
      //     children: [],
      //     tags: [],
      //   },

      //   {
      //     title: this.$t("event.menu.toolshelpers.title"),
      //     icon: "tools",
      //     tags: this.$t("event.menu.toolshelpers.searchterms"),
      //     seperator: false,
      //     slug: "tools",
      //     children: [
      //         {
      //           title: this.$t("event.menu.rsvps.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.rsvps.searchterms"),
      //           badge: "0",
      //           slug: "rsvp",
      //         },

      //         {
      //           title: this.$t("event.menu.certificastes.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.certificastes.searchterms"),
      //           badge: "0",
      //           slug: "certificates",
      //         },

      //         {
      //           title: this.$t("event.menu.tableplanner.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.tableplanner.searchterms"),
      //           badge: "0",
      //           slug: "seating-planner",
      //         },

      //         {
      //           title: this.$t("event.menu.tweetwall.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.tweetwall.searchterms"),
      //           badge: "0",
      //           slug: "tweet-wall",
      //         }

      //     ],
      //   },

      //   {
      //     title: this.$t("event.menu.onsiteutilities.title"),
      //     icon: "onsite",
      //     tags: this.$t("event.menu.onsiteutilities.searchterms"),
      //     seperator: false,
      //     slug: "modules",
      //     children: [
      //         {
      //           title: this.$t("event.menu.promotions.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.promotions.searchterms"),
      //           badge: "0",
      //           slug: "promotions",
      //         },

      //         {
      //           title: this.$t("event.menu.controlpoints.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.controlpoints.searchterms"),
      //           badge: "0",
      //           slug: "venues",
      //         },

      //         {
      //           title: this.$t("event.menu.controlequipments.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.controlequipments.searchterms"),
      //           badge: "0",
      //           slug: "mobile-control",
      //         },

      //         {
      //           title: this.$t("event.menu.badgedesigner.title"),
      //           icon: "",
      //           tags: this.$t("event.menu.badgedesigner.searchterms"),
      //           badge: "0",
      //           slug: "print-scheme",
      //         }

      //     ],
      //   },

      //   {
      //     title: this.$t("event.menu.messages.title"),
      //     icon: "messages",
      //     tags: this.$t("event.menu.messages.searchterms"),
      //     seperator: false,
      //     badge: "0",
      //     slug: "automated-messages",
      //     children: [],
      //   },

      //   {
      //     title: this.$t("event.menu.eventusers.title"),
      //     icon: "users",
      //     tags: this.$t("event.menu.eventusers.searchterms"),
      //     seperator: false,
      //     badge: "0",
      //     slug: "users",
      //     children: [],
      //   },

      // ],
      searchTerm: ""
    };
  },
  computed: {
    eventMenuKey() {
      return this.$store.getters.getEventMenuKey;
    },
    role() {
      return this.$store.getters.getEventRole;
    },
    getDashboardItems() {
      return this.$store.getters.getDashboardItems;
    },
    getMenuItems() {
      var role = this.role;
      var re = new RegExp(this.getSearchTerm, "gi");
      console.log("getMenuItems", role);
      this.menuKey += 1;
      var dummyMenu = JSON.parse(JSON.stringify(this.menus));
      if (role != null) {
        dummyMenu = dummyMenu.filter(x => x.role.includes(role));
      }
      if (this.searchTerm != null && this.searchTerm != "") return dummyMenu.filter(k => k.title.match(re) || k.children.some(x => x.title.match(re) || x.tags.some(ee => ee.match(re))) || k.tags.some(q => q.match(re)));
      else return dummyMenu;
    },
    getSearchTerm() {
      return slugify(this.searchTerm == null ? "" : this.searchTerm, " ");
    }
  },
  async mounted() {
    // await this.getStatistics();
    this.initMenu();
  },
  watch: {
    searchTerm: function() {
      this.$nextTick(() => {
        this.initMenu();
      });
    }
  },
  methods: {
    async getStatistics() {
      var res = await axios.post("Statistics/BasicStatistics", {});
      if (!res.data.alert.hasError) {
        this.statistics = res.data.data.items;
        console.log(this.statistics);
      }
    },
    getSubMenuItems(slug) {
      var index = this.menus.findIndex(k => k.slug == slug);
      var re = new RegExp(this.getSearchTerm, "gi");
      var dummyChildren;
      if (this.role != null) {
        dummyChildren = this.menus[index].children.filter(x => x.role.includes(this.role));
      }

      if (this.searchTerm != null && this.searchTerm != "") return dummyChildren.filter(k => k.title.match(re) || k.tags.some(q => q.match(re)));
      else return dummyChildren;
    },
    initMenu() {
      // Define default class names and options
      var navClass = "nav-sidebar",
        navItemClass = "nav-item",
        navItemOpenClass = "nav-item-open",
        navLinkClass = "nav-link",
        navSubmenuClass = "nav-group-sub",
        navSlidingSpeed = 250;

      $("." + navClass).each(function() {
        $(this)
          .find("." + navItemClass)
          .has("." + navSubmenuClass)
          .children("." + navItemClass + " > " + "." + navLinkClass)
          .not(".disabled")
          .off("click");
      });

      // Configure collapsible functionality
      $("." + navClass).each(function() {
        $(this)
          .find("." + navItemClass)
          .has("." + navSubmenuClass)
          .children("." + navItemClass + " > " + "." + navLinkClass)
          .not(".disabled")
          .on("click", function(e) {
            e.preventDefault();

            // Simplify stuff
            var $target = $(this),
              $navSidebarMini = $(".sidebar-xs")
                .not(".sidebar-mobile-main")
                .find(".sidebar-main ." + navClass)
                .children("." + navItemClass);

            // Collapsible
            if ($target.parent("." + navItemClass).hasClass(navItemOpenClass)) {
              $target
                .parent("." + navItemClass)
                .not($navSidebarMini)
                .removeClass(navItemOpenClass)
                .children("." + navSubmenuClass)
                .slideUp(navSlidingSpeed);
            } else {
              $target
                .parent("." + navItemClass)
                .not($navSidebarMini)
                .addClass(navItemOpenClass)
                .children("." + navSubmenuClass)
                .slideDown(navSlidingSpeed);
            }

            // Accordion
            if ($target.parents("." + navClass).data("nav-type") == "accordion") {
              $target
                .parent("." + navItemClass)
                .not($navSidebarMini)
                .siblings(":has(." + navSubmenuClass + ")")
                .removeClass(navItemOpenClass)
                .children("." + navSubmenuClass)
                .slideUp(navSlidingSpeed);
            }
          });
      });

      // Disable click in disabled navigation items
      $(document).on("click", "." + navClass + " .disabled", function(e) {
        e.preventDefault();
      });

      // Scrollspy navigation
      $(".nav-scrollspy")
        .find("." + navItemClass)
        .has("." + navSubmenuClass)
        .children("." + navItemClass + " > " + "." + navLinkClass)
        .off("click");
    }
  }
};
</script>
<style>
.sidebar-xs .menu-search-wrapper {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/EventMenu.vue